export const HomePictures = [
  {
    src: "https://files.seeusercontent.com/2026/08/12/gp0D/4b5176e0ae1628472bc61501c5d5c7d6.jpg",
    nameKey: "home.portrait",
    link: "/portrait",
  },
  {
    src: "https://files.seeusercontent.com/2026/06/28/6biA/d37c6b7a_yjbnDpGBtLWI36a.jpg",
    nameKey: "home.wedding",
    link: "/wedding",
  },
  {
    src: "https://s2.loli.net/2025/02/27/rBlDxnhvjQUtyca.png",
    nameKey: "home.event",
    link: "/event",
  },
  {
    src: "https://s2.loli.net/2025/03/31/zIx92d5ZvMCFjiB.jpg",
    nameKey: "home.commercial",
    link: "/commercial",
  },
  {
    src: "https://s2.loli.net/2025/01/07/MvmucSb2K1jLsk4.jpg",
    nameKey: "home.pets",
    link: "/pets",
  },
  {
    src: "https://s2.loli.net/2025/02/27/jRBkL4C8naAeZoy.jpg",
    nameKey: "home.fashion",
    link: "/fashion",
  },
  {
    src: "https://s2.loli.net/2025/01/07/CPd16jsGqlAtJ7E.jpg",
    nameKey: "home.destination",
    link: "/destination",
  },
  {
    src: "https://s2.loli.net/2025/01/07/1IuTFotHzXQaqmj.jpg",
    nameKey: "home.creative",
    link: "/creative",
  },
  {
    src: "https://s2.loli.net/2025/02/27/mA6hedTNRKFzIoH.jpg",
    nameKey: "home.scenery",
    link: "/scenery",
  },
];
